<template>
  <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="movimento.id"
      :headers="headers"
      :items="movimentiSorted"
      :options.sync="options"
      :server-items-length="totaleMovimenti"
      :loading="loading"
      class="elevation-1"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      @update:options="getDataFromApi"
    >
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | dateTime }}
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template> 
    </v-data-table>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import movimenti from '@/services/movimentiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import _ from 'lodash'

  /* eslint-disable */
  export default {
    props: {
      item: Object,
      refresh: Number
    },
    data: () => ({
        totaleMovimenti: 0,
        movimenti: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Data', value: 'data', align: 'start'},
          { text: 'Magazzino', value: 'magazzino' },
          { text: 'Quantità', value: 'quantita' },
          { text: 'Valore', value: 'valore' },
          { text: 'Causale', value: 'causale' },
          { text: 'Tipo', value: 'riferimento.tipo' },
          { text: 'Riferimento', value: 'riferimento.id' }
        ],      
        filtri: null,
        causali: []
    }),
    watch: {
      async refresh() {
        await this.getDataFromApi()
      }
    },
    async mounted() {  
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.causali = _.get(backoffice, 'prodotti.storico.causaliVendita', ['venditaClienti', 'annullamentoScontrino'])
      await this.getDataFromApi()
    },
    computed: {
      movimentiSorted() {
        return this.movimenti
        /*         const els = this.movimenti
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted */
      }   
    },
    methods: {
      async getDataFromApi () {
        try {
          if (this.causali.length === 0) return
          this.loading = true
          // passo periodo e causali da considerare
          this.filtri = {}
          this.filtri.prodotto = this.item._id
          // console.log(this.filtri.prodotto)
          this.filtri.causale = [...this.causali]
          const data = await movimenti.getMovimentiProdottoFisso(this.filtri, this.options)
          this.movimenti = data && data.total_rows > 0 ? data.rows : []
          // toglie annullato e annullamento
          const annullati = this.movimenti.filter(x => x.causale === 'annullamentoScontrino') // da impostazioni ?
          const idAnnullati = annullati.map(x => x.riferimento.id)
          this.movimenti = this.movimenti.filter(x => x.causale !== 'annullamentoScontrino' && !idAnnullati.includes(x.riferimento.id))
          this.totaleMovimenti = data.total_rows - 2 * annullati.length
        } catch(err) {
          this.movimenti = []
          this.totaleMovimenti = 0
        } finally {
          this.loading = false
        }
      }
    
    }
  }
</script>
